<div class="container">
  <div class="row">
    <div class="col">
      <h3 class="text_color mt-4">Select apppliance category</h3>
    </div>
  </div>

  <div class="row mt-4">
    <div
      class="col-6 card_items"
      *ngFor="let category of categories; let index = odd"
      [ngClass]="odd ? 'odd' : 'even'"
    >
      <div class="card" (click)="selectCard(category)">
        <div class="card-body">
          <img
            src="{{ category.image }}"
            alt="ac"
            class="img-fluid d-block m-auto"
            style="width: 50px;"
          />
          <p class="text-center font-weight-bold mt-2">{{ category.name }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="container">
  <div class="row">
    <div class="col">
      <h3 class="text_color mt-4">Select apppliance category</h3>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <div class="card">
        <h6 class="card-title">AIR CONDITIONER</h6>
        <div class="card-body">
          <div class="row">
            <div class="col-3 text-center"  *ngFor="let ac of ac; let index = odd"
            [ngClass]="odd ? 'odd' : 'even'">
              <img
                src={{ac.image}}
                alt="ac"
                style="height: 30px"
                class="img-fluid"
              />
              <br>
              <small class="text-danger text-center" style="font-size: 12px;">{{ ac.name }}</small>
            </div>
          </div>
          <h6 class="header_title mt-3 mb-3"> WASHING MACHINE </h6>
          <div class="row">
            <div class="col-3 text-center"  *ngFor="let wm of wm; let index = odd"
            [ngClass]="odd ? 'odd' : 'even'">
              <img
                src={{wm.image}}
                alt="ac"
                style="height: 30px"
                class="img-fluid"
              />
              <br>
              <small class="text-danger text-center" style="font-size: 12px;">{{ wm.name }}</small>
            </div>
          </div>
          <h6 class="header_title mt-3 mb-3"> GEYSER </h6>
          <div class="row">
            <div class="col-3 text-center"  *ngFor="let geyser of geyser; let index = odd"
            [ngClass]="odd ? 'odd' : 'even'">
              <img
                src={{geyser.image}}
                alt="ac"
                style="height: 30px"
                class="img-fluid"
              />
              <br>
              <small class="text-danger text-center" style="font-size: 12px;">{{ geyser.name }}</small>
            </div>
          </div>
          <h6 class="header_title mt-3 mb-3"> HEATING DEVICE  </h6>
          <div class="row">
            <div class="col-3 text-center"  *ngFor="let heating_device of heating_device; let index = odd"
            [ngClass]="odd ? 'odd' : 'even'">
              <img
                src={{heating_device.image}}
                alt="ac"
                style="height: 30px"
                class="img-fluid"
              />
              <br>
              <small class="text-danger text-center" style="font-size: 12px;">{{ heating_device.name }}</small>
            </div>
          </div>
          <h6 class="header_title mt-3 mb-3"> WATER PUMP  </h6>
          <div class="row">
            <div class="col-3 text-center"  *ngFor="let water_pump of water_pump; let index = odd"
            [ngClass]="odd ? 'odd' : 'even'">
              <img
                src={{water_pump.image}}
                alt="ac"
                style="height: 30px"
                class="img-fluid"
              />
              <br>
              <small class="text-danger text-center" style="font-size: 12px;">{{ water_pump.name }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
